var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-container"},[(_vm.showChat && _vm.userID)?_c('chat-container',{attrs:{"current-user-id":_vm.userID,"theme":_vm.theme}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }